import React, { useState, useEffect } from "react";

const Navbar = ({ currentPage, setCurrentPage, years }) => {
	const [dropdownOpen, setDropdownOpen] = React.useState(false);
	const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

	const handleYearClick = (year) => {
		setCurrentPage(year);
		setDropdownOpen(false);
		setMobileMenuOpen(false);
	};

	const handleHomeClick = () => {
		setCurrentPage("home");
		setMobileMenuOpen(false);
	};

	return (
		<header className="navbar">
			<nav>
				<h3>
					<a
						href="#"
						onClick={(e) => {
							e.preventDefault();
							handleHomeClick();
						}}
					>
						Nemec Christmas Letters
					</a>
				</h3>

				{/* Desktop Menu */}
				<ul>
					<li>
						<a
							href="#"
							onClick={(e) => {
								e.preventDefault();
								handleHomeClick();
							}}
							className={currentPage === "home" ? "active" : ""}
						>
							Home
						</a>
					</li>
					<li
						className="dropdown"
						onMouseEnter={() => setDropdownOpen(true)}
						onMouseLeave={() => setDropdownOpen(false)}
					>
						<a href="#" onClick={(e) => e.preventDefault()}>
							Letters ▾
						</a>
						{dropdownOpen && (
							<ul className="dropdown-menu">
								{years.map((year) => (
									<li key={year}>
										<a
											href="#"
											onClick={(e) => {
												e.preventDefault();
												handleYearClick(year);
											}}
											className={currentPage === year ? "active" : ""}
										>
											{year}
										</a>
									</li>
								))}
							</ul>
						)}
					</li>
				</ul>

				{/* Mobile Menu Button */}
				<button
					className="mobile-menu-button"
					onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
				>
					☰
				</button>
			</nav>

			{/* Mobile Menu */}
			<div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
				<ul>
					<li>
						<a
							href="#"
							onClick={(e) => {
								e.preventDefault();
								handleHomeClick();
							}}
							className={currentPage === "home" ? "active" : ""}
						>
							Home
						</a>
					</li>
				</ul>
				<div className="mobile-years">
					<ul>
						{years.map((year) => (
							<li key={year}>
								<a
									href="#"
									onClick={(e) => {
										e.preventDefault();
										handleYearClick(year);
									}}
									className={currentPage === year ? "active" : ""}
								>
									{year}
								</a>
							</li>
						))}
					</ul>
				</div>
			</div>
		</header>
	);
};


export default Navbar;